/* eslint-disable no-nested-ternary */
import { useContext, JSX } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthProvider';

import IconButton from '../../../juristec-ui/core/IconButton';
import Button from '../../../juristec-ui/core/Button';
import { StyledNoFile, StyledOuterNoFile } from './styled/EmptyList.styled';
import { NoFileDashboard, Add } from '../../../juristec-ui/icons';

const systemMap = () => {
  switch (process.env.REACT_APP_FIREBASE_PROJECT_LABEL) {
    case 'legalone-analytics':
      return 'Legal One Analytics';
    case 'benner-metrics':
      return 'Benner Metrics';
    case 'legalmetrics':
      return 'Legal Metrics';
    default:
      return 'Sistema';
  }
};

interface DashboardsListEmptyProps {
  typeMsg?: string;
  toggle?: () => void;
}

const DashboardsListEmpty = ({
  typeMsg = 'empty', toggle = () => {},
}: DashboardsListEmptyProps): JSX.Element => {
  const { user } = useContext(AuthContext);
  return (
    <StyledOuterNoFile>
      <StyledNoFile>
        <div className="content">
          <p className="firstphrase">
            {typeMsg !== 'empty' ? (
              typeMsg === 'emptyTrash' ? (
                <b>Sua lixeira está vazia!</b>
              ) : (
                <b>Não achamos o que você procura!</b>
              )
            ) : (
              <span>
                <b>Nenhum dashboard criado!</b>
                {' '}
                <br />
                {' '}
                {user?.role !== 'guest' ? (
                  <>
                    Para criar um dashboard clique no botão
                    {' '}
                    <IconButton
                      onClick={toggle}
                      color="secondary"
                    >
                      <Add />

                    </IconButton>
                    {' '}
                    no canto superior direito.
                  </>
                ) : (
                  <>
                    Você não possui permissão para criar um dashboard, por enquanto!
                  </>
                )}
              </span>
            )}
          </p>
          <NoFileDashboard />
          {typeMsg === 'empty' ? (
            <>
              <p>
                {user?.role !== 'guest' ? (
                  <>
                    Caso você ainda não possua nenhuma base instalada, faça upload de um arquivo
                    {' '}
                    <b>.csv</b>
                    {' '}
                    ou
                    {' '}
                    <b>.xlsx</b>
                    {' '}
                    na página
                    {' '}
                    <NavLink
                      to="/arquivos"
                      className="navlink"
                    >
                      Arquivos
                    </NavLink>
                    {' '}
                    para ter acesso a todos os recursos do
                    {' '}
                    {systemMap()}
                    .
                  </>
                ) : null}
              </p>
            </>
          ) : (
            typeMsg === 'emptyTrash' ? (
              <>
                <div className="gap-fix">
                  Para voltar clique no botão
                  {' '}
                  <Button
                    onClick={toggle}
                    color="secondary"
                    variant="contained"
                    size="small"
                  >
                    Retornar
                  </Button>
                  {' '}
                  no canto superior direito.
                </div>
              </>
            ) : (
              <>
                <p>
                  Você não possui nenhum dashboard com qualquer um desses parâmetros:
                  {' '}
                  <b>Nome, Grupo ou Usuário</b>
                </p>
              </>
            )
          )}

        </div>
      </StyledNoFile>
    </StyledOuterNoFile>
  );
};

export default DashboardsListEmpty;
